module.exports = __webpack_public_path__ + "img/image_btn.c6e12d41.jpg";